import { createReducer, on } from "@ngrx/store"

import { AuthActions } from "./action-types"

export interface AuthState {
	user: any
	loading: boolean
}

export const initialAuthState: AuthState = {
	user: undefined,
	loading: false
}

export function authReducer(state, action) {
	return _authReducer(state, action)
}

const _authReducer = createReducer(
	initialAuthState,

	on(AuthActions.saveUser, (state, action) => {
		return {
			...state,
			user: action.user
		}
	}),

	on(AuthActions.loginRequest, state => {
		return {
			...state,
			loading: true
		}
	}),

	on(AuthActions.loginSuccess, state => {
		return {
			...state,
			loading: false
		}
	}),

	on(AuthActions.loginError, state => {
		return {
			...state,
			loading: false
		}
	}),

	on(AuthActions.logout, state => {
		return {
			...state,
			user: undefined
		}
	})
)
